<template>
    <div>
        <Header></Header>
        <div class="top-message">
            <h1>購入した商品</h1>
            <div class="purchasedResult">
                <div v-if="!purchasedResult.length" class="noItem">
                    <p>購入した商品はありません</p>
                </div>
                <ul>
                    <li v-for="purchased in purchasedResult" :key="purchased.itemID">
                        <article>
                            <figure>
                                <img :src="purchased.img_url" @click="goTrade(purchased)">
                            </figure>
                            <div class="text-content">
                                <p>{{purchased.item}}</p>
                                <button class="goTrade" @click="goTrade(purchased)">取引画面へ</button>
                            </div>
                        </article>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../components/Header.vue'
import db from '../plugins/firestore'
import firebase from '../plugins/firebase'

export default {
    components: {Header},
    data(){
        return {
            purchasedList: [], //購入した商品IDを入れる
            purchasedResult: [] //商品情報を入れるための配列
        }
    },
    created() {
        firebase.auth().onAuthStateChanged(user => {
            if(!user){
                this.$router.push({path: "/"})
            }else{
                var userID = user.uid
                var self = this
                //usersコレクションから、購入した商品IDを取得してpurchasedListに突っ込む
                db.collection("users").doc(userID).collection("purchases").get().then(function(querySnapshot){
                    let purchasedList = []
                    querySnapshot.forEach((doc) => {
                        purchasedList.push(doc.id)
                    });
                    self.purchasedList = purchasedList
                })
                .then(() => {
                    //purchasedListの商品IDの数だけループを回して、firestoreから取ってくる。
                    let purchasedResult = []
                    for(var i = 0; i < self.purchasedList.length; i++){
                        db.collection("textbooks").doc(self.purchasedList[i]).get().then(function(doc){
                        if (doc.exists) {
                            const data = doc.data()
                            data.itemID = doc.id
                            purchasedResult.push(data)
                        } else {
                            // doc.data() will be undefined in this case
                            console.log("PurchasedList : No such document!");
                        }
                        })
                    }
                    self.purchasedResult = purchasedResult
                })
            }
        }) 
    },
    methods: {
        goTrade(purchased){
            this.$store.dispatch('goTrade', purchased)
            this.$router.push({path:"/trade"})
        }
    }
}
</script>

<style scoped>
.purchasedResult {
    margin: 0 auto;
    width: 35%;
}

.noItem{
    margin: 20px;
}

article {
	display: flex;
	margin-bottom: 5px;
	padding: 15px;
	border-radius: 5px;
	box-sizing: border-box;
	box-shadow: 0 0 5px #999;
}

article figure {
	margin-right: 20px;
	width: 70px;
	height: 70px;
}

article figure img {
    width: 70px;
    height: 70px;
    vertical-align: top;
    object-fit: cover;
}

button {
    float: left;
}

.goTrade {
    border-radius: 4px;
    color: white;
    margin-top: 5px;
    padding: 4px 20px;
    background-color: rgb(53, 174, 243);
    opacity: 0.8;
}

ul {
    list-style: none;
}

li {
    margin: 10px;
}


@media all and (max-width:670px){
    .purchasedResult{
        width: 90%;
    }

    img {
        width: 90px;
        height: 90px;
    }
}
</style>